import authState from './shared/state';

export default {
  modules: {
    authState,
  },
};
